module.exports = __webpack_public_path__ + "img/mwCircle.ea43a35e.jpg";